import { NotificationActionTypes, All } from '../actions/notification.actions';
import { RequestStatus } from '@app/shared/models/requestStatus';

// define State interface
export interface State {
  // is a user authenticated?
  token:string;
  currentMessage: any;
  successStatus: RequestStatus | null;
  actionType:string;
  errorStatus: RequestStatus | null;
}

// define initial state
export const initialState: State = {
  token:null,
  currentMessage: null,
  successStatus:null,
  actionType:null,
  errorStatus: null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    // case NotificationActionTypes.GET_PERMISSION_SUCCESS:{
    //   return {
    //     ...state,
    //     token: action.payload.token,
    //     currentMessage: null,
    //     actionType: action.type,
    //   };
    // }
    // case NotificationActionTypes.GET_PERMISSION_FAILURE: {
    //   return {
    //     ...state,
    //     errorStatus: action.payload.errorStatus,
    //     actionType:action.type,
    //   };
    // }
    case NotificationActionTypes.SEND_TEAM_NOTIFICATION_SUCCESS:{
      return {
        ...state,
        //token: action.payload.token,
        //currentMessage: null,
        successStatus:action.payload.successStatus,
        actionType: action.type,
      };
    }
    case NotificationActionTypes.SEND_TEAM_NOTIFICATION_FAILURE: {
      return {
        ...state,
        successStatus:null,
        errorStatus: action.payload.errorStatus,
        actionType:action.type,
      };
    }
    default: {
      return {
        ...state,
        successStatus:null,
        errorStatus:null
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/notification.reducer.ts